import './App.css';
import { DynamicContextProvider, useDynamicContext , useDynamicModals, DynamicUserProfile } from '@dynamic-labs/sdk-react-core';
import { EthereumWalletConnectors } from "@dynamic-labs/ethereum";
import TopBar from "./TopBar";
import Footer from "./Footer";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useUser } from "./context/user-context";
import { useWallet } from "./context/wallet-context";
import { formatUnits } from "viem";
import { isProd } from "./utils/isProd";
import PasswordGate from "./services/PasswordGate";


function App() {
    let dynamic = process.env.REACT_APP_DYNAMIC_DEV;
    if(isProd) 
    {        
        dynamic = process.env.REACT_APP_DYNAMIC_PROD;
    }
    return (
        <PasswordGate>
        <DynamicContextProvider
            settings={{
                environmentId: dynamic,
                walletConnectors: [EthereumWalletConnectors],
            }}
        >
            <MainApp />
        </DynamicContextProvider>
        </PasswordGate>
    );
}

function MainApp() {
    const { t } = useTranslation();
    const {  mvUser } = useUser();
    const {userBalance } = useWallet();
    const { setShowAuthFlow, setShowDynamicUserProfile, user, authToken } = useDynamicContext();
    const [clientLoaded, setClientLoaded] = useState(false);
    const [unityInitialized, setUnityInitialized] = useState(false);
    const [skipClicked, setSkipClicked] = useState(false);
    useEffect(() => {
        if (!user) {
            setSkipClicked(false);
        }
    }, [user]);
    
    useEffect(() => {
        if (unityInitialized || !user || !skipClicked) return;
        if (user) {
            try {
                console.log("Initializing Unity...");
                var element = document.getElementById("unity-webgl-build-script");
                console.log(element)
                if (element) {
                    console.log("Removing old Unity script...");
                    element.parentNode.removeChild(element);
                }
                const buildUrl = `${process.env.REACT_APP_PUBLIC_URL}${process.env.REACT_APP_VERSION}/RevvRacing/`;
                const loaderUrl = `${buildUrl}Build/RevvRacing.loader.js`;

                const buildFolderUrl = `${buildUrl}Build`;
                const config = {
                    dataUrl: buildFolderUrl + "/RevvRacing.data.unityweb",
                    frameworkUrl: buildFolderUrl + "/RevvRacing.framework.js.unityweb",
                    codeUrl: buildFolderUrl + "/RevvRacing.wasm.unityweb",
                    streamingAssetsUrl: buildUrl + "StreamingAssets",
                    companyName: "TDF",
                    productName: "RevvRacing",
                    productVersion: process.env.VITE_RR_BUILD_VERSION || "0.0.1", // Default version
                };
                console.log(config)
                const unityLoaderScript = document.createElement("script");
                unityLoaderScript.src = loaderUrl;
                unityLoaderScript.id = "unity-webgl-build-script";
                unityLoaderScript.async = true;
                unityLoaderScript.onload = () => createUnityInstance(config);
                document.head.appendChild(unityLoaderScript);
                setUnityInitialized(true);
            } catch (error) {
                console.error("Error initializing Unity:", error);
            }
        }
    }, [user,unityInitialized, skipClicked]);

    useEffect(() => {
        if (!clientLoaded || !user || (!userBalance && !skipClicked)) return;

        console.log('hello')
        console.log("Preparing to send data to Unity...");
        try {
            const ethRevv = formatUnits(
                userBalance?.revv?.balance || 0,
                userBalance?.revv?.decimals || 18
            );
            const payload = {
                userBalance: Math.floor(ethRevv).toString(),
                userId: user?.userId || "",
                username: user?.username || user?.email || "Guest",
                userAuth: authToken || "",
                isProd,
            };
            console.log("Payload to Unity:", payload);

            // Vérifier l'état de l'instance avant d'envoyer
            if (window.unityInstance) {
                window.unityInstance.SendMessage(
                    "RevvGameSessionService",
                    "Ready",
                    JSON.stringify(payload)
                );
                console.log("Message sent to Unity.");
            } else {
                console.warn("Unity instance not ready yet. Retrying...");
            }
        } catch (e) {
            console.error("Error sending data to Unity:", e);
        }
    }, [clientLoaded, userBalance, user, authToken, skipClicked]);


    const createUnityInstance = async (config) => {
            console.log("Creating Unity instance...");            
            var loader = document.getElementById("loader");
            var container = document.getElementById("unity-container");
            var canvas = document.getElementById("unity-canvas");
            canvas.style.width = window.innerWidth + 'px';
            canvas.style.height = window.innerHeight + 'px';
            if (window.innerWidth > window.innerHeight) {
                canvas.style.width = window.innerHeight * 16 / 9 + 'px';
            } else {
                canvas.style.height = window.innerWidth * 9 / 16 + 'px';
            }

            try {
                window.unityInstance = await window.createUnityInstance(canvas, config);
                console.log("Unity instance created successfully:", window.unityInstance);
                loader.style.display = "none";
                container.style.background = "black";
                setClientLoaded(true)
            } catch (error) {
                console.error("Failed to create Unity instance:", error);
            }
    }

    return (
        <>
        <DynamicUserProfile variant="modal" />
        <div className={ !user ? "App" : ""}>
            {!skipClicked && (
                <div>
                    <TopBar />
                    <header className="App-header">
                        <section>
                            <h2 className="text-white tex-uppercase anton">
                                {t("THE COMPETITION IS HEATING UP!")}
                            </h2>
                            <p className="oxanium text-white fz-15">
                                {t(
                                    "Join the REVV Motorsport metaverse, compete and earn REVV against other drivers from around the world, in this arcade simulation car racing blockchain game developed by Animoca Brands!"
                                )}
                            </p>
                        </section>
                        {!user ? (
                            <button onClick={() => setShowAuthFlow(true)} className="play-now-button text-uppercase oxanium">
                                {t("Play Now")}
                            </button>
                        ) : (
                            <div className='options-container'>
                                <button onClick={() => setSkipClicked(true)} className="play-now-button text-uppercase oxanium">
                                    {t("Play Now")}
                                </button>
                                <button onClick={() =>{
                                    console.log("showDynamicUserProfile") 
                                    setShowDynamicUserProfile(true)}} className="play-now-button text-uppercase oxanium">
                                    {t("Link/UnLink Wallet")}
                                </button>
                                
                            </div>
                        )}
                    </header>
                    <Footer />
                </div>
            )}
            {user && skipClicked && (
                <div
                    id="unity-container"
                    className="unity-container"
                >
                    <div id="loader" className="loader"></div>
                    <canvas id="unity-canvas"></canvas>
                </div>
            )}
        </div>
        </>
    );
}

export default App;
